import {authContext} from 'context/AuthContext';
import {uploadStreamChunks} from './uploadEncryptedStreamChunks';

type UploadMode = 'native' | 'multipart';

function isFirefox(): boolean {
   return navigator.userAgent.toLowerCase().includes('firefox');
}

function supportsDuplexStreams(): boolean {
   try {
      const stream = new ReadableStream();
      // Creating a Request with a ReadableStream body and duplex hints feature support
      // is sufficient to detect modern streaming upload capability in Chromium-based browsers
      // without actually sending the request.
      // @ts-ignore
      new Request('about:blank', {method: 'POST', body: stream, duplex: 'half'});
      return true;
   } catch {
      return false;
   }
}

function chooseUploadMode(): UploadMode {
   const canStream = supportsDuplexStreams() && !isFirefox();
   return canStream ? 'native' : 'multipart';
}

/**
 * Encrypts file and uploads using best available strategy (native stream or multipart).
 */
export async function encryptAndUpload(
   file: File,
   publicKeyArmored: string,
   refetchFolder: () => Promise<void>,
   path: string,
   encrypt: boolean
): Promise<void> {
   console.debug('start encrypt and upload');

   // const mode = chooseUploadMode();
   // console.debug(`Using ${mode} upload`);

   try {
      await uploadStreamChunks(file, publicKeyArmored, refetchFolder, path, encrypt);
      // if (mode === 'native') {
      //    await uploadStreamedNative(file, publicKeyArmored, refetchFolder);
      // } else {
      //    await uploadEncryptedStreamChunks(file, publicKeyArmored, refetchFolder);
      // }
   } catch (error) {
      console.error('encryptAndUpload failed:', (error as Error).message);
      throw error;
   }
}
